<div
  class="flex flex-col rounded-lg border border-gray-200 bg-neutral-98 shadow-sm">
  <div class="border-b-2 border-neutral-95 p-4">
    <span class="text-lg font-medium text-primary-60" i18n>
      Centros de Trabajo
    </span>
  </div>
  <div class="flex flex-col lg:h-80 lg:flex-row">
    <div class="h-60 overflow-hidden lg:h-full lg:w-1/2">
      <qaroni-workplaces-map height="100%" [workplacesList]="workplaces()" />
    </div>
    <div class="flex flex-col p-0 lg:w-1/2">
      <div class="flex-1 overflow-auto">
        @for (
          workplace of workplaces() | slice: 0 : 3;
          track workplace.workplaceId;
          let isFirst = $first;
          let isLast = $last
        ) {
          <qaroni-workplace-widget-item
            [workplace]="workplace"
            [first]="isFirst" />
        }
      </div>
      <div
        class="flex items-center justify-between bg-neutral-95 p-4 text-sm"
        *qaroniRoleAccessPermission>
        <a
          class="qaroni-link-on-surface text-sm"
          tabindex="0"
          (click)="goToWorkplacesList()"
          (keypress)="goToWorkplacesList()"
          i18n>
          Ver todos
        </a>
        <button
          class="qaroni-link-on-surface flex items-center gap-1 text-sm"
          (click)="goToCreateWorkplace()"
          (keypress)="goToCreateWorkplace()">
          <mat-icon
            fontIcon="add_business"
            class="material-symbols-outlined h-fit w-fit text-lg" />
          <ng-container i18n>Agregar centro de trabajo</ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
